import React, { useEffect, useState, useMemo, useContext, useRef } from "react";

import axios from "axios";
import { Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import { AppContext } from "../../../context/AppContext";
import { toastError, toastWarn } from "../../../common/Toast";
import { Noimage } from "../../../common/imagePath";
import "tabulator-tables/dist/css/tabulator.min.css";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import ReportDate from "../../../components/Reports/ReportDate";
import ReportCurrencySymbol from "../../../common/Reportcurrencysymbols";
import moment from "moment";

const ProfitByDeliveryMethodsSummary = (props) => {
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deliveryMethods, setDeliveryMethods] = useState([]);
  const [deliveryMethodsId, setDeliveryMethodId] = useState([]);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(1);
  Number(locationid);
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    currencySymbolLocation,
  } = useContext(AppContext);

  console.log(deliveryMethodsId, "deliveryMethodsIdcheck");

  const apiCall = () => {
    setLoading(true);
    setResponseData([]);

    axios
      .get(
        `${config.reportsBaseUrl}/reports/profitbydeliverymethodsummary?&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&deliverymethodid=${deliveryMethodsId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          if (res.data.ResponseData?.length > 0) {
            setLoading(false);
          } else {
            toastWarn("No Records Found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went Wrong");
        setLoading(false);
        return;
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Delivery Method drop down
    axios
      .get(`${config.deliveriesBaseUrl}/deliveries/deliverymethodlist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const deliveryData =
          response.data.ResponseData?.map((el) => {
            return { label: el.Name, value: el.ID };
          }) || [];

        const noDeliveryOption = { label: "No delivery method", value: 100 };

        setDeliveryMethods([noDeliveryOption, ...deliveryData]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columns = [
    {
      title: "Delivery Method",
      headerFilter: "input",
      field: "DeliveryMethod",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "Total Deliveries",
      headerFilter: "input",
      field: "TotalDeliveries",
      defaultVisible: true,
      bottomCalc: "sum",
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return "0.0";
        }
        return Number(totalValue).toFixed(2);
      },

      // Make cell clickable
      cellClick: function (e, cell) {
        const rowData = cell.getRow().getData();

        const deliveryMethod = rowData.DeliveryMethodId; // adjust field name if different
        const startDate = startdate; // must be in scope
        const endDate = enddate; // must be in scope
        const selectedreportperiod = selectReport; // must be in scope

        // Construct the URL (update the path and query params as needed)
        const detailURL = `/profit-by-delivery-methods-detail?deliveryMethod=${deliveryMethod}&startDate=${startDate}&endDate=${endDate}&selectedreportperiod=${selectedreportperiod}`;

        // Navigate to the detail page
        window.open(detailURL, "_blank");
        // window.location.href = detailURL;
      },

      // Optional: Make it look like a link (styling)
      formatter: function (cell) {
        const value = cell.getValue();
        return `<span style="
      color: #333;
      font-weight: bold;
      text-decoration: underline;
      cursor: pointer;
    ">${value}</span>`;
      },
    },
    {
      title: "Revenue",
      headerFilter: "input",
      field: "Revenue",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return "0.0";
        }
        return ReportCurrencySymbol(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return "0.0";
        }

        return ReportCurrencySymbol(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "COGS",
      headerFilter: "input",
      field: "COGS",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return "0.0";
        }
        return ReportCurrencySymbol(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return "0.0";
        }

        return ReportCurrencySymbol(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Delivery Fees",
      headerFilter: "input",
      field: "DeliveryFees",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return "0.0";
        }
        return ReportCurrencySymbol(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return "0.0";
        }

        return ReportCurrencySymbol(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Profit",
      headerFilter: "input",
      field: "Profit",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return "0.0";
        }
        return ReportCurrencySymbol(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return "0.0";
        }

        return ReportCurrencySymbol(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
     {
      title: "Average Order",
      headerFilter: "input",
      field: "AverageOrder",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return "0.0";
        }
        return ReportCurrencySymbol(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return "0.0";
        }

        return ReportCurrencySymbol(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
     {
      title: "Average Profit",
      headerFilter: "input",
      field: "AverageProfit",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return "0.0";
        }
        return ReportCurrencySymbol(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return "0.0";
        }

        return ReportCurrencySymbol(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    // {
    //   title: "Average Order",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   field: "AverageOrder",
    //   defaultVisible: true,
    //   bottomCalc: "avg",
    //   bottomCalcFormatter: function (cell) {
    //     const totalValue = cell.getValue(); // sum of all SaleTotal
    //     if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
    //       return "0.0";
    //     }

    //     return Number(totalValue).toFixed(2);
    //   },
    // },
    // {
    //   title: "Average Profit",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   field: "AverageProfit",
    //   defaultVisible: true,
    //   bottomCalc: "avg",
    //   bottomCalcFormatter: function (cell) {
    //     const totalValue = cell.getValue(); // sum of all SaleTotal
    //     if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
    //       return "0.0";
    //     }
    //     return Number(totalValue).toFixed(2);
    //   },
    // },
  ];

  useEffect(() => {
    localStorage.removeItem("columnVisibility");
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Profit By Delivery Methods Summary
                </li>
              </ul>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-4">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-auto">
              <label className="col-form-label col-md-12">
                Delivery Methods
              </label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    options={deliveryMethods}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    isMulti={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(selected) =>
                      setDeliveryMethodId(selected?.map((e) => e.value) || [])
                    }
                    value={deliveryMethods.filter((b) =>
                      deliveryMethodsId.includes(b.value)
                    )}
                    className="reports-filter-custom-width custom-select-search z-5"
                  />
                </div>
              </div>
            </div>
            <div className="col-auto align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={() => {
                  apiCall();
                }}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">
                        Profit By Delivery Methods Summary
                      </p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <div>
                      <CommonTabular
                        Data={responseData}
                        columns={columns}
                        Groupvalue={["ItemName"]}
                        Reportname={"Profit By Delivery Methods Summary"}
                        frozenRowvalue={0}
                        Onrefresh={() => apiCall()}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfitByDeliveryMethodsSummary;
